import { render, staticRenderFns } from "./CertificationsWrapper.vue?vue&type=template&id=2b443b80"
import script from "./CertificationsWrapper.vue?vue&type=script&lang=js"
export * from "./CertificationsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports